/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */
'use strict';
export default class AuthApiFactory {

  constructor ($q, $log, $http, API_CONFIG, $ngRedux) {
    'ngInject';

    this._logger = $log.getInstance('authApiService');
    this._$q = $q;
    this.$http = $http;
    this.API_CONFIG = API_CONFIG;
    this.$ngRedux = $ngRedux;
    this._logger.log('instantiated');
  }


  getStatus (opts) {
    this._logger.log('getStatus', opts);
    return this.$http.get(this.API_CONFIG.basePath + '/status', {
      opts
    })
  }

  static serviceFactory($q, $log, $http, API_CONFIG, $ngRedux){
    'ngInject';
    AuthApiFactory.instance = new AuthApiFactory($q, $log, $http, API_CONFIG, $ngRedux);
    return AuthApiFactory.instance;
  }
}



// WEBPACK FOOTER //
// ./client/components/api-service/auth-api.factory.js